// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"17":"mobile/playback","200":"wix-i18n-config_intl-pluralrules","366":"mobile/share-popup-content","397":"widget/vod-player","536":"new","894":"wix-i18n-config_intl-relativetimeformat"}[chunkId] || chunkId) + ".chunk.min.js";
};